/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Auth_SessionInputs */

const cs_import_auth_session = /** @type {(inputs: Import_Auth_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít mé přihlášení`)
};

const en_import_auth_session = /** @type {(inputs: Import_Auth_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use my signed-in session`)
};

/**
* | output |
* | --- |
* | "Use my signed-in session" |
*
* @param {Import_Auth_SessionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_auth_session = /** @type {((inputs?: Import_Auth_SessionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Auth_SessionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_auth_session(inputs)
	return cs_import_auth_session(inputs)
});